import { useMemo } from 'react';
import { isEmptyObject } from '../../../../../core/util/object';

export default (
  requiredData: any,
  userProfile: any,
  insuranceProfile: any,
  insuranceDetails: any
) => {
  return useMemo(() => {
    const data = { userProfile, insuranceProfile, insuranceDetails };
    // @ts-expect-error ts-migrate(7053) FIXME: Element implicitly has an 'any' type because expre... Remove this comment to see the full error message
    for (const requirement of requiredData) if (isEmptyObject(data[requirement])) return true;

    return false;
  }, [requiredData, userProfile, insuranceDetails, insuranceProfile]);
};
